<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>{{ name }}</h2>
                    <router-link tag="a" :to="'/admin/users/add'" class="btn btn-info waves-effect m-t-15"
                                 style="margin: 15px 0">Добавить
                    </router-link>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>Время захода</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.created_at }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const Swal = require('sweetalert2');

    export default {
        name: "historyUser",
        props: ['message'],
        data() {
            return {
                items: [],
                name: '',
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/users/' + this.$route.params.id)
                .then(response => {
                    this.name = response.data.user.name;
                    this.items = response.data.user.history;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },
    }
</script>





// WEBPACK FOOTER //
// src/views/app/admin/users/history.vue